var _a;
import { Benefit_Inquiry_Topic_Area } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Benefit_Inquiry_Topic_Area.Accumulator] = 'Accumulator',
    _a[Benefit_Inquiry_Topic_Area.Copay] = 'Copay',
    _a[Benefit_Inquiry_Topic_Area.DrugCoverage] = 'Drug Coverage',
    _a[Benefit_Inquiry_Topic_Area.Other] = 'Other',
    _a);
export var TopicAreaEnum = {
    name: 'TopicArea',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
